import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Layout from "@/components/Layout";
import { api } from "@/lib/api";

export default function Pricing() {
  const [s, setS] = useState({});
  useEffect(() => { api.get("/public/settings").then((r) => setS(r.data)).catch(() => {}); }, []);

  const slabs = s.pricing_slabs_inr || [];

  return (
    <Layout>
      <section className="container-msis py-16">
        <div className="overline mb-3">Pricing</div>
        <h1 className="font-display font-bold text-4xl sm:text-5xl tracking-tighter max-w-3xl">Simple, transparent pricing for individuals and institutions.</h1>
      </section>

      <section className="container-msis pb-12">
        <div className="grid lg:grid-cols-2 gap-px bg-border">
          {/* INDIVIDUAL INR */}
          <div className="bg-white p-8" data-testid="price-individual-inr">
            <div className="overline">Individual · India</div>
            <div className="mt-3 font-display font-bold text-4xl tracking-tight">₹{s.individual_price_inr || 360}<span className="text-base font-medium text-slate2 ml-2">/ test</span></div>
            <ul className="mt-6 space-y-2 text-sm text-slate2">
              <li>· Single-use Test ID</li>
              <li>· OTP-verified email</li>
              <li>· Detailed PDF report</li>
              <li>· One test per subscriber</li>
            </ul>
            <Link to="/checkout?plan=individual_inr" className="btn-primary mt-6" data-testid="buy-individual-inr">Buy Test</Link>
          </div>
          {/* INDIVIDUAL USD */}
          <div className="bg-white p-8" data-testid="price-individual-usd">
            <div className="overline">Individual · International</div>
            <div className="mt-3 font-display font-bold text-4xl tracking-tight">${s.individual_price_usd || 9}<span className="text-base font-medium text-slate2 ml-2">/ test</span></div>
            <ul className="mt-6 space-y-2 text-sm text-slate2">
              <li>· Single-use Test ID</li>
              <li>· OTP-verified email</li>
              <li>· Detailed PDF report</li>
              <li>· One test per subscriber</li>
            </ul>
            <Link to="/checkout?plan=individual_usd" className="btn-primary mt-6" data-testid="buy-individual-usd">Buy Test</Link>
          </div>
        </div>
      </section>

      <section className="container-msis pb-24">
        <div className="grid lg:grid-cols-2 gap-px bg-border">
          {/* INSTITUTIONAL INR */}
          <div className="bg-white p-8" data-testid="price-institution-inr">
            <div className="overline">Institutional · India (slab)</div>
            <div className="mt-3 font-display font-bold text-3xl tracking-tight">Volume pricing</div>
            <table className="w-full mt-5 text-sm">
              <thead><tr className="border-b border-border text-slate2 text-xs uppercase tracking-wider">
                <th className="text-left py-2">Tests</th><th className="text-right py-2">Per test</th>
              </tr></thead>
              <tbody>
                {slabs.map(([lo, hi, p]) => (
                  <tr key={lo} className="border-b border-border last:border-b-0">
                    <td className="py-2 font-mono">{lo}{hi > 100000 ? "+" : `–${hi}`}</td>
                    <td className="py-2 text-right font-mono">₹{p}</td>
                  </tr>
                ))}
              </tbody>
            </table>
            <Link to="/checkout?plan=institution_inr" className="btn-primary mt-6" data-testid="buy-institution-inr">Subscribe</Link>
          </div>
          {/* INSTITUTIONAL USD */}
          <div className="bg-white p-8" data-testid="price-institution-usd">
            <div className="overline">Institutional · International</div>
            <div className="mt-3 font-display font-bold text-4xl tracking-tight">${s.institutional_price_usd || 9}<span className="text-base font-medium text-slate2 ml-2">/ test</span></div>
            <div className="text-sm text-slate2 mt-3">Flat-rate pricing for any number of tests.</div>
            <ul className="mt-6 space-y-2 text-sm text-slate2">
              <li>· Bulk Test ID generation</li>
              <li>· Institution dashboard</li>
              <li>· Aggregate analytics</li>
              <li>· Per-student PDF reports</li>
            </ul>
            <Link to="/checkout?plan=institution_usd" className="btn-primary mt-6" data-testid="buy-institution-usd">Subscribe</Link>
          </div>
        </div>
      </section>
    </Layout>
  );
}
